import React, { useState } from 'react';
import { useAppSelector } from 'hooks';

import { AuthTags } from '~constants/authTags';

import { Button, ConfirmDialog, Select } from '~components';
import Icon, { faArrowRightArrowLeft } from '~components/icon';

import { lookupClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';

interface ComponentProps {
  selectedIds: string[];
  onBulkUpdate: (statusId: string) => void | Promise<void>;
  canUpdate: boolean;
}

const BulkUpdateStatus: React.FC<ComponentProps> = ({ selectedIds, onBulkUpdate, canUpdate }) => {
  const budgetStatusOptions = useAppSelector(lookupClientBudgetStatuses);
  const [statusId, setStatusId] = useState<string | null>(null);
  const [isBulkUpdateConfirmOpen, setIsBulkUpdateConfirmOpen] = useState(false);

  const hasSelection = selectedIds.length > 0;
  const isDisabled = !canUpdate || !hasSelection;

  const onConfirm = (confirmed: boolean) => {
    setIsBulkUpdateConfirmOpen(false);
    if (confirmed) {
      onBulkUpdate(statusId || '');
      setStatusId(null);
    }
  };

  return (
    <div className="d-flex align-items-center me-2">
      <Select
        id="budgets-bulk-update-status-select"
        name="budgets-bulk-update-status-select"
        className="me-2"
        size="sm"
        placeholder="Bulk update status..."
        options={budgetStatusOptions}
        value={statusId || undefined}
        onChange={(_, value) => setStatusId(value)}
        disabled={!canUpdate}
      />
      <Button
        id="budgets-bulk-update-button"
        size="sm"
        disabled={isDisabled || !statusId}
        onClick={() => setIsBulkUpdateConfirmOpen(true)}
        authTag={AuthTags.CLIENTS.BUDGETS.UPDATE}
      >
        <Icon className="me-2" icon={faArrowRightArrowLeft} />
        Bulk Update
      </Button>
      <ConfirmDialog
        isOpen={isBulkUpdateConfirmOpen}
        messages={`You are about to update the status of ${selectedIds.length} selected budgets.`}
        onClose={onConfirm}
      />
    </div>
  );
};

export default BulkUpdateStatus;
